<template>
  <van-notice-bar class="box-border" v-if="swipe" left-icon="/assets/img/award/redMoney2x.png" :scorllable="false">
    <van-swipe class="notice-swipe" :show-indicators="false">
      <template v-if="!hideRewardPrompt">
        <template v-if="award">
          <van-swipe-item>
            <div class="phone-award-count award-notice-text">
              <span>前</span>
              <strong>
                <span class="text-medium text-black text-opacity-80">
                  {{ quantityAward }}
                </span>
              </strong>
              <span>名提交</span>
              <template v-if="needAuditFlagAward">
                <span>并审核通过</span>
              </template>
              <span>的答题人，可获得</span>
              <strong>
                <span class="text-medium text-red text-opacity-80">
                  {{ $bus.convertAwardAmountText(award) }}
                </span>
              </strong>
              <span>现金红包</span>
            </div>
          </van-swipe-item>
        </template>
        <template v-else-if="hadAward">
          <van-swipe-item>
            <div class="phone-award-count">问卷红包已被领完</div>
          </van-swipe-item>
        </template>
      </template>
      <template v-if="!hideShareRewardPrompt">
        <template v-if="share">
          <van-swipe-item>
            <div class="phone-share-count">
              <span>前</span>
              <strong
                ><span class="text-medium text-black text-opacity-80">
                  {{ quantityShare }}
                </span></strong
              >
              <span>名完成的分享人，可获得</span>
              <strong>
                <span class="text-medium text-red text-opacity-80">
                  {{ $bus.convertAwardAmountText(share) }}
                </span>
              </strong>
              <span>现金红包</span>
            </div>
          </van-swipe-item>
        </template>
        <template v-else-if="hadShare">
          <van-swipe-item>
            <div class="phone-award-count">分享奖励已被领完</div>
          </van-swipe-item>
        </template>
      </template>
      <template v-if="surveyPoint">
        <van-swipe-item>
          <div class="phone-share-count">
            <span>前</span>
            <strong>
              <span class="text-medium text-black text-opacity-80">
                {{ surveyPoint.limit }}
              </span>
            </strong>
            <span>名提交</span>
            <template v-if="needAuditFlagAward">并审核通过</template>
            <span>的答题人，可获得</span>
            <strong>
              <span class="text-medium text-red text-opacity-80">
                {{ surveyPoint.point }}
              </span>
            </strong>
            <span>积分</span>
          </div>
        </van-swipe-item>
      </template>
    </van-swipe>
  </van-notice-bar>
</template>

<script>
import { busGetters } from 'dygc'

export default {
  name: 'AwardNotice',
  computed: {
    needAuditFlagAward() {
      return this.$bus.enableNetManualAudit
    },
    hideRewardPrompt() {
      return this.survey.hideRewardPrompt !== 0
    },
    hideShareRewardPrompt() {
      return this.survey.hideShareRewardPrompt !== 0
    },
    amountShare({ share }) {
      return share && share.amount
    },
    quantityShare({ share }) {
      return share && share.quantity
    },
    quantityAward({ award }) {
      return award && award.quantity
    },
    amountAward({ award }) {
      return award && award.amount
    },
    swipe() {
      return (this.hadAward && !this.hideRewardPrompt) || (this.hadShare && !this.hideShareRewardPrompt) || this.surveyPoint
    },
    ...busGetters(['hadAward', 'hadShare', 'award', 'share', 'survey', 'surveyPoint'])
  }
}
</script>
